import React, { useEffect, useState } from "react";

export function ExpiryCountdown ({
  subject,
  expiresAt
}: {
  subject?: string,
  expiresAt: string
}) {
  const [, setTick] = useState(0);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setTick(v => v + 1);
    }, 800);
    return () => window.clearInterval(timer);
  }, []);

  const remainingMs = new Date(expiresAt).valueOf() - Date.now();
  const remainingS = Math.floor(remainingMs / 1000);
  if (remainingS <= 0) {
    return (
      <div>{subject} expired</div>
    );
  } else {
    return (
      <div>{subject} expires in {remainingS} seconds</div>
    );
  }
}
